import { configFile } from '../config';
// import ErrorMessage from '../utils/ErrorMessage.json';
import PropTypes from 'prop-types';
import axiosIntance from '../lib/axios';
import { prepareMessageFromError } from '../utils/common';
const { endPoints } = configFile;
import ErrorMessage from '../utils/ErrorMessage.json';
import Logger from '../lib/Logger';
const logger = new Logger("apisCall")
import { MailFilterEndpoint } from 'src/config/config.local';

// create api post call for all post method apis.
const axiosPostCall = async (endPointName, data = {}, completeResponse = false) => {
  try {
    const url = endPoints(endPointName);
    const response = await axiosIntance.post(url, data);

    if (completeResponse) return response;
    if (response?.status === 200) {
      return response?.data;
    }
    throw new Error(ErrorMessage?.[4000]);
  } catch (error) {
    throw new Error(prepareMessageFromError(error));
  }
};

axiosPostCall.propTypes = {
  endPointName: PropTypes.string.isRequired, // Api end point url name added in config.
  data: PropTypes.object, // Method body data.
  completeResponse: PropTypes.bool, // Pass true if you want received completed response insted of data.
};

// create api get call for all get method apis.
const axiosGetCall = async (endPointName, data = {}, completeResponse = false) => {
  try {
    const url = endPoints(endPointName);
    const response = await axiosIntance.get(url, { params: data });

    if (completeResponse) return response;
    if (response?.status === 200) {
      return response?.data;
    }
    throw new Error(ErrorMessage?.[4000]);
  } catch (error) {
    throw new Error(prepareMessageFromError(error));
  }
};

const axiosPatchCall = async (endPointName, data = {}, completeResponse = false) => {
  try {
    const url = endPoints(endPointName); // Get the endpoint URL
    const response = await axiosIntance.patch(url, data); // Make the PATCH request

    if (completeResponse) return response; // Return the entire response if requested
    if (response?.status === 200) {
      return response?.data; // Return only the data if the status is 200
    }
    throw new Error(ErrorMessage?.[4000]); // Throw error with a default message if the status is not 200
  } catch (error) {
    throw new Error(prepareMessageFromError(error)); // Handle error with a custom message preparation function
  }
};


const handleLogout = async () => {
  try {
    return await axiosPostCall("logout")
  }
  catch (error) {
    logger.error("apisCall.js [handleLogout] catchError", error);
    throw new Error(error);
  }
}

axiosGetCall.propTypes = {
  endPointName: PropTypes.string.isRequired, // Api end point url name added in config.
  data: PropTypes.object, // Method body data.
  completeResponse: PropTypes.bool, // Pass true if you want received completed response insted of data.
};

const axiosMailGetCall = async (endpoint, data1 = {}, completeResponse = false) => {
  try {
    const url = MailFilterEndpoint(endpoint);
   const response = await axiosIntance.get(url, data1);

    if (completeResponse) return response?.data;
    if (response?.status === 200) {
      return response?.data;
    }

    throw new Error(ErrorMessage?.[4000]);
  } catch (error) {
    throw new Error(prepareMessageFromError(error));
  }
};

const axiosMailPostCall = async (endpoint, data = {}, completeResponse = false) => {
  try {
    const url = MailFilterEndpoint(endpoint);
    const response = await axiosIntance.post(url, data);

    if (completeResponse) return response;

    if (response?.status === 200) {
      return response?.data;
    }

    throw new Error(ErrorMessage?.[4000]);
  } catch (error) {
    throw new Error(prepareMessageFromError(error));
  }
};


export { axiosPostCall, axiosGetCall, handleLogout, axiosPatchCall, axiosMailGetCall, axiosMailPostCall };
